import { Interval, ModeOfTransport, IntervalDays } from "./FrontendTypes";
import EnumInput from "../components/EnumInput";
import NumberInput from "../components/NumberInput";
import { BikeTrip } from "./FrontendTypes";


function createBikeTrip(toCustomer: boolean): BikeTrip {
    return {
        mot: ModeOfTransport.BIKE,
        distance: 20,
        frequency: 1,
        interval: Interval.WEEK,
        toCustomer: toCustomer
    }
}

type Props = {
    value: BikeTrip,
    setValue: React.Dispatch<React.SetStateAction<any>>
}

function BikeComponent({value: bike, setValue: setBike}: Props) {

    const setDistance = (newDistance: number) => {
        setBike({ ...bike, distance: newDistance });
    };

    const setFrequency = (newFrequency: number) => {
        setBike({ ...bike, frequency: newFrequency });
    };

    const handleIntervalChange = (newInterval: Interval) => {
        setBike({ ...bike, interval: newInterval });
    };

    return (
        <>
            <NumberInput
                max={999}
                value={bike.distance}
                setValue={setDistance}
            />
            <p>km mit dem Fahrrad, pro</p>
            <EnumInput
                value={bike.interval}
                enumType={Interval}
                onChange={handleIntervalChange}
            />
            <p>ca. </p>
            <NumberInput
                max={IntervalDays[bike.interval]}
                value={bike.frequency}
                setValue={setFrequency}
            />
            <p> mal</p>
        </>
    );
}

export { type BikeTrip as Type, BikeComponent as Component, createBikeTrip as createTrip };